//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

export enum UniversalPostableCustomStatus {
  NoAction = 'no_action',
  PostInitiated = 'post_initiated',
  PostHidden = 'post_hidden',
}
